import React from "react";
import { FormikProps, Field, FieldProps } from "formik";
import { Button, Grid, FormHelperText } from "@material-ui/core";
import { inject, observer } from "mobx-react";
import { IManagementStore } from "@src/Stores/Management/types";
import { computed, observable } from "mobx";
import ClearIcon from "@material-ui/icons/Clear";
import { Values } from "@src/Tools/Values";
import { IValuesStore } from "@src/Stores/Values/types";
import { STTextField, STGrid, STInputLabel, STButtonsGrid, STFab, STPreviewImage } from "./styles";

interface IProps<T> {
  fieldName: string;
  label: string;
  formikProps: FormikProps<T>;
  management?: IManagementStore;
  values?: IValuesStore;
  isEdit: boolean;
  imageUrl: string;
  hasImageSet: boolean;
}

@inject("management", "values")
@observer
export default class FileField<T> extends React.Component<IProps<T>> {
  @observable file: any;

  handleFileChange = (e: any) => {
    e.persist();

    this.file = URL.createObjectURL(e.currentTarget.files[0]);
    this.props.formikProps.setFieldValue(this.props.fieldName as string, e.currentTarget.files[0]);
  };

  handleResetFile = (fieldName: string) => {
    this.file = null;
    let fieldNames = fieldName.split(".");
    if (fieldNames.length > 1) {
      this.props.formikProps.values[fieldNames[0]][fieldNames[1]] = new File([], "reset");
    } else {
      this.props.formikProps.setFieldValue(fieldName, new File([], "reset"));
    }
  };

  handleOpen = (fieldName: string) => {
    const fileNode: any = document.querySelector(`#fileInput${fieldName.split(".")[1]}`);
    fileNode.click();
  };

  hasImage = () => this.file && this.props.imageUrl !== "";

  @computed get previewImageSrc() {
    if (this.hasImage()) {
      return this.file;
    }
    return "";
  }

  @computed get isError() {
    return (
      this.props.formikProps.touched[this.props.fieldName] && !!this.props.formikProps.errors[this.props.fieldName]
    );
  }

  componentDidMount() {
    if (this.props.isEdit && this.props.hasImageSet) {
      this.file = `${this.props.values.filesPath}${this.props.imageUrl}`;
    }
  }

  render() {
    return (
      <>
        <Field
          name={this.props.fieldName}
          render={({ field }: FieldProps) => (
            <STTextField
              type="file"
              fullWidth
              label={this.props.label}
              onChange={this.handleFileChange}
              id={`fileInput${field.name.split(".")[1]}`}
              inputProps={{
                accept: "image/*",
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          )}
        />

        <STGrid container justify="space-between" alignItems="center">
          <Grid item xs={12}>
            <STInputLabel>{this.props.label}</STInputLabel>
          </Grid>
          <STButtonsGrid item container alignItems="center">
            <Grid item>
              <Button variant="contained" color="primary" onClick={() => this.handleOpen(this.props.fieldName)}>
                {Values.getLocalizationValue("openFile")}
              </Button>
            </Grid>
            {this.hasImage() && (
              <Grid item>
                <STFab size="small" onClick={() => this.handleResetFile(this.props.fieldName)}>
                  <ClearIcon />
                </STFab>
              </Grid>
            )}
          </STButtonsGrid>
          <Grid item>
            <STPreviewImage src={this.previewImageSrc} alt="" />
          </Grid>
          <Grid item xs={12}>
            {this.isError && (
              <FormHelperText error={true}>
                {this.props.formikProps.touched[this.props.fieldName] &&
                  this.props.formikProps.errors[this.props.fieldName]}
              </FormHelperText>
            )}
          </Grid>
        </STGrid>
      </>
    );
  }
}
